

















































































































interface TrialBalanceData {
    dfljbalance: string
    jfljbalance: string
    ljresult: null;
    ljstate: null;
    message: string;
    qcdfbalance: string;
    qcjfbalance: string;
    qcresult: null;
    qcstate: number;
}
import { Component, Vue, Prop } from "vue-property-decorator";
import { mapGetters } from "vuex";
@Component({
    components: {
    },
    ...mapGetters(["accountBook"])
})
export default class TrialBalance extends Vue {
    @Prop({ type: String })
    startPeriod?: string;

    intPeriod: string = ""
    testBalanceData: TrialBalanceData | null = null
    mounted() {
        Vue.axios
            .post(`subjects/` + this.$store.state.accountBook.id + `/findbalance`, {
            })
            .then(res => {
                this.testBalanceData = res.data
                if (this.startPeriod) {
                    this.intPeriod =
                        this.startPeriod.substring(0, 4) +
                        "-" +
                        this.startPeriod.substring(5, 7);
                }
            });
    }

}
